import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PersonalitySummary extends Component {
  static propTypes = {
    description: PropTypes.string,
    personalityTypeAcronym: PropTypes.string,
    fullPersonalityType: PropTypes.string,
  }

  render() {
    const { personalityTypeAcronym, fullPersonalityType, description } = this.props
    return (
      <div>
        <h4 className="text-center mt-4 mb-3">
          You're an <strong>{personalityTypeAcronym}!</strong>
        </h4>
        <h6>{fullPersonalityType}</h6>
        <p>{description}</p>
      </div>
    )
  }
}

export default PersonalitySummary



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/components/PersonalitySummary.js